"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allAxis = void 0;
exports["default"] = AxisFields;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _SliderInput = _interopRequireDefault(require("../SliderInput"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var allAxis = {
  left: {
    key: 'axisLeft',
    other: 'right'
  },
  right: {
    key: 'axisRight',
    other: 'left'
  },
  top: {
    key: 'axisTop',
    other: 'bottom'
  },
  bottom: {
    key: 'axisBottom',
    other: 'top'
  }
};
exports.allAxis = allAxis;
function AxisFields(_ref) {
  var field = _ref.field,
    form = _ref.form,
    axis = _ref.axis;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Label",
    name: "".concat(field.name, ".").concat(allAxis[axis].key, ".legend"),
    component: _cccisdFormik.CccisdInput
  }), /*#__PURE__*/_react["default"].createElement(_SliderInput["default"], {
    label: "Text Rotation",
    name: "".concat(field.name, ".").concat(allAxis[axis].key, ".tickRotation"),
    min: 0,
    max: 360,
    step: 1
  }));
}